import React from 'react';
import SideBar from '../../../shared/templates/CategoryTemplate/category-sidebar';

function FoodSideBar(props) {
  return (<SideBar {...props} 
    section="food"
    searchTitle="Search Foods"
    createNewTitle="New Food"
    filterList={[
      { name:'keywords', value: 'Enter Keywords' }, 
    ]}
  />);
}

export default FoodSideBar;